import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { TextField } from '@material-ui/core'

import {
  Button,
  Checkbox,
  DialogConfirm,
} from 'ui/components'

import Restrictions from 'ui/components/plan/Restrictions'

import {
  postGeneratePlan,
} from 'services/apiMotorBgc'

import { PLAN_POLE_TYPE } from 'utils/constants/planPoleTypes'

import styles from './styles'

export default ({ docType, onSubmit = null }) => {
  const classes = styles()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [planName, setPlanName] = useState('')
  const [description, setDescription] = useState('')
  const [visibleToOrganization, setVisibleToOrganization] = useState(false)
  const [processPole, setProcessPole] = useState(PLAN_POLE_TYPE.PASSIVE)
  const [planServices, setPlanServices] = useState([])

  const planNameValid = () => {
    return planName.length >= 3 && planName.length <= 100
  }

  const descriptionValid = () => {
    return description.length <= 200
  }

  const processPoleValid = () => {
    return _.values(PLAN_POLE_TYPE).includes(processPole)
  }

  const planServicesValid = () => {
    const planServicesChecked = _.filter(planServices, { checked: true })

    return planServicesChecked.length >= 1
  }

  const formValid = () => {
    if (!planNameValid()) return false
    if (!descriptionValid()) return false
    if (!processPoleValid()) return false
    if (!planServicesValid()) return false

    return true
  }

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const handleCancel = () => {
    setModalOpen(false)
  }

  const handleProcessPole = (val) => {
    setProcessPole(val)
  }

  const handlePlanServices = (val) => {
    setPlanServices(val)
  }

  const handlePlanCreate = async () => {
    setLoading(true)

    try {
      await postGeneratePlan(
        apiKey,
        userId,
        docType,
        planName,
        description || null,
        visibleToOrganization,
        planServices,
        processPole,
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao criar plano'
      toast.error(messageError)
      setLoading(false)
      return
    }

    setLoading(false)
    setModalOpen(false)
    toast.success('Plano criado com sucesso!')

    if (_.isFunction(onSubmit)) onSubmit()
  }

  const renderPlanNameInput = () => {
    return (
      <TextField
        id="name"
        label="Nome do plano"
        type="text"
        value={planName}
        onChange={(e) => setPlanName(e.target.value)}
        required={true}
        autoCapitalize="off"
        autoCorrect="off"
        error={!planNameValid()}
        inputProps={{
          minLength: 3,
          maxLength: 100,
        }}
      />
    )
  }

  const renderDescriptionInput = () => {
    return (
      <TextField
        id="description"
        label="Descrição do plano"
        type="text"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required={false}
        autoCapitalize="off"
        autoCorrect="off"
        error={!descriptionValid()}
        fullWidth={true}
        multiline={true}
        minRows={3}
        size="medium"
        inputProps={{
          minLength: 3,
          maxLength: 200,
        }}
      />
    )
  }

  const renderCheckboxVisibleToOrganization = () => {
    return (
      <div style={{ marginTop: 20 }}>
        <Checkbox
          value={visibleToOrganization}
          label="Compartilhar plano com outros usuários da minha organização"
          onClick={setVisibleToOrganization}
        />
      </div>
    )
  }

  const renderRestrictions = () => {
    return (
      <Restrictions
        docType={docType}
        processPole={processPole}
        planServices={planServices}
        onChangeProcessPole={handleProcessPole}
        onChangePlanServices={handlePlanServices}
      />
    )
  }

  const renderContent = () => {
    return (
      <form className={classes.contentContainer}>
        {renderPlanNameInput()}
        {renderDescriptionInput()}
        {renderCheckboxVisibleToOrganization()}
        {renderRestrictions()}
      </form>
    )
  }

  return (
    <div>
      <Button onClick={handleToggleModal}>
        Criar Plano
      </Button>

      <DialogConfirm
        title="Criar Plano"
        open={modalOpen}
        onCancel={handleCancel}
        onConfirm={handlePlanCreate}
        content={renderContent()}
        btnConfirmDisabled={loading || !formValid()}
        btnConfirmText="Criar"
        btnCancelText="Cancelar"
      />
    </div>
  )
}
